<template>
    <!-- 最近購入した商品 ここから  -->
    <div v-if="pt510Init.isDisplay" class="pt510" id="pt510" v-cloak>
        <!-- 最近購入した商品 -->
        <div class="itemTitle">
            <h3>{{$t('pt510.labels.title')}}</h3>
        </div>
        <div class="sliderProductList">
            <Carousel :per-page="7" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayTimeout="4000">
                <slide class="sliderProduct" v-for="(item, index) in pt510Init.relationList" :key="index">
                    <router-link :to="{ name: SiteConstants.PG030 , params: {pageNo: 3, sItemNo: item.S_ITEM_NO}}" @click.native="reload">
                        <img class="sliderProductImg" :src="item.IMG_URL1" @error="getErrImage" :alt="$t('pt510.labels.title')"/>
                    </router-link>
                    <!--レビューする-->
                    <button v-if="ptInitData && ptInitData.reviewFlg == '1'" class="toReviewBtn" @click="doReview(item.S_ITEM_NO, item.ORDER_CD, item.SEQ);">
                        {{$t('pt510.labels.review')}}
                    </button>
                    <router-link :to="{ name: SiteConstants.PG030, params: {pageNo: 3, sItemNo: item.S_ITEM_NO}}" @click.native="reload">
                        <span class="sliderProductNm">{{item.WEB_ITEM_NM}}</span>
                    </router-link>
                </slide>
            </Carousel>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import Message from 'components/Message';
import { Carousel, Slide } from 'vue-carousel';
import SiteConstants from 'assets/const/SiteConstants.json';
import { mapMutations } from 'vuex';

export default {
    /* 
    * Name of component
    */
    name: "PT510OrderItemParts",

    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },

    components:{
        InputCheck,
        InputNumber,
        Message,
        Carousel,
        Slide
    },
    data() {
        return {
            pt510Init: {
                relationList: [],
                isDisplay:false,
            },
            pt510ReqModel:{},
            SiteConstants:SiteConstants,
            site: ""
        }
    },
    watch: {
        pt510Init: {
            handler(value) {
                this.syncPt510InitState(value);
            },
            deep: true,
            immediate: true,
        },
        pt510ReqModel: {
            handler(value) {
                this.syncPt510ReqModelState(value);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData) {
            if (_this.ptInitData.relationList != null && _this.ptInitData.relationList.length > 0) {
                _this.pt510Init.relationList = _this.ptInitData.relationList;
                _this.pt510Init.isDisplay = true;
            }
        } else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT510 + _this.$UrlConstants.DO_INIT).then(function(response) {
                if (response.data.relationList != null && response.data.relationList.length > 0) {
                    _this.pt510Init.relationList = response.data.relationList;
                    _this.pt510Init.isDisplay = true;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    
    methods: {
        ...mapMutations('pt510', {
            commitSetPt510Init: 'SET_PT510_INIT',
            commitSetPt510ReqModel: 'SET_PT510_REQ_MODEL'
        }),
        syncPt510InitState(payload) {
            this.commitSetPt510Init(Object.assign({}, payload));
        },
        syncPt510ReqModelState(payload) {
            this.commitSetPt510ReqModel(Object.assign({}, payload));
        },
        syncPt510ReqModelState(payload) {
            this.commitSetPt510ReqModel(Object.assign({}, payload));
        },
        
        /*
        * レビュー処理
        */
        doReview: function(sItemCd,orderCd,seq) {
          let _this = this;
          _this.$router.push({ name: _this.SiteConstants.PG010MAIN,query: { pageNo: 83}, params: {orderCd: orderCd,itemCd: sItemCd,seq: seq}} );
        },
        // goto pg030
        gotoPg030: function(sItemNo){
            this.$router.push({ name: this.SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /**
         * Reload page
         */
        reload: function() {
            window.location.reload();
        },
    },
    created() {
        const pt510StoreState = this.$store && this.$store.state && this.$store.state.pt510
            ? this.$store.state.pt510
            : null;

        if (pt510StoreState) {
            if (pt510StoreState.pt510Init && Object.keys(pt510StoreState.pt510Init).length > 0) {
                this.pt510Init = Object.assign({}, this.pt510Init, pt510StoreState.pt510Init);
            }
            if (pt510StoreState.pt510ReqModel && Object.keys(pt510StoreState.pt510ReqModel).length > 0) {
                this.pt510ReqModel = Object.assign({}, this.pt510ReqModel, pt510StoreState.pt510ReqModel);
            }
        }

        const paramData = this.$route.params || {};
        const queryData = this.$route.query || {};

        if (Object.keys(paramData).length > 0) {
            this.pt510ReqModel = Object.assign({}, this.pt510ReqModel, paramData);
        }
        if (Object.keys(queryData).length > 0) {
            this.pt510ReqModel = Object.assign({}, this.pt510ReqModel, queryData);
        }
    },
}
</script>
